module.exports = __webpack_public_path__ + "fd916de1efa97f60c375afea42a8563d.svg";